"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeSelector = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("@amzn/monera-app-core/lib/theme");
const theme_provider_1 = require("../theme-provider");
const ThemeSelector = (props) => {
    const { children, theme: overriddenTheme } = props;
    let theme = theme_1.coreTheme;
    if (overriddenTheme) {
        theme = overriddenTheme;
    }
    return react_1.default.createElement(theme_provider_1.ThemeProvider, { theme: theme }, children);
};
exports.ThemeSelector = ThemeSelector;
